/**
 * Imports the Freighthub API.
 */
import { api } from '../api.js';

export default {
    /**
     * GET api.freighthub.nz/carrier/gps/schedules-kpi-reports/export
     */
    get: function( params ){
        return api.get( '/carrier/gps/schedules-kpi-reports/export' , { params: params } );
    },
}